import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import FilterTitleBar from "./FilterTitleBar";
import SubSectionFields from "./../containers/SubSectionFields";
import MultiSelectCheckbox from "./../containers/MultiSelectCheckbox";
import { filterChoices } from "./../../common/services/Filters";
import "./../styles/FilterPanel.css";

export interface Props {
  filters: Function;
  onTitleClick: Function;
}

interface State {
  detailSection: string;
  detailFields: string[];
}

class FilterPanel extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { detailSection: "", detailFields: [] };
    this.drillDown = this.drillDown.bind(this);
    this.drillUp = this.drillUp.bind(this);
  }

  drillDown(sectionName: string, fields: string[] = []) {
    this.setState({ detailSection: sectionName, detailFields: fields });
  }

  drillUp() {
    this.setState({ detailSection: "", detailFields: [] });
  }

  render() {
    const defaultFilterView = (
      <div className="ds-u-border--1 ds-u-border--dark ds-u-margin-bottom--0 ds-u-padding--2 filter-fixed-overflow">
        {this.props.filters({ onDrillDown: this.drillDown })}
      </div>
    );

    const drilldownView = (
      <div>
        <FilterDrilldown
          drilldownSection={this.state.detailSection}
          fields={this.state.detailFields}
          onBackButtonClick={this.drillUp}
        />
        <div className="printOnly">{defaultFilterView}</div>
      </div>
    );

    const contents = this.state.detailSection
      ? drilldownView
      : defaultFilterView;

    return (
      <div>
        <FilterTitleBar collapsed={false} onClick={this.props.onTitleClick} />
        {contents}
      </div>
    );
  }
}

export const FilterDrilldown = ({
  drilldownSection,
  fields,
  onBackButtonClick,
}: any) => {
  // TODO: Refactor once we settle on these form controls - they are subject to substantial redesign
  // Need to remove any reference to specific field names and make more generic

  let contentComponent = (
    <SubSectionFields fields={fields} detailSection={drilldownSection} />
  );
  if (
    drilldownSection === "selectedStates" ||
    drilldownSection === "selectedStatesAlpha"
  ) {
    contentComponent = (
      <MultiSelectCheckbox
        label="Select State/Territories"
        choices={filterChoices[drilldownSection]}
        filterName={drilldownSection}
      />
    );
  }

  return (
    <div>
      <div className="ds-u-border--1 ds-u-margin-bottom--2 ds-u-radius ds-u-padding--2 ds-u-md-padding--4 filter-fixed-overflow">
        <div className="ds-l-row">
          <button
            type="button"
            className="ds-c-button ds-c-button--transparent ds-u-color--base"
            onClick={onBackButtonClick}
          >
            <FontAwesomeIcon icon="arrow-left" />
            <label className="ds-u-margin-left--2 backHover">Back</label>
          </button>
        </div>
        {contentComponent}
      </div>
    </div>
  );
};

export default FilterPanel;
